import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getIsTrailer } from 'helpers/vehicle'
import { TRAILER_TITLE } from 'constant'
import VehicleTile from '../../VehicleTile'
import AddVehicleTile from '../../AddVehicleTile'
import { GenericTrailerTile, TrailerTile } from '../TrailerTile'

const VehicleSelectorButtonGroup = ({
  vehicles,
  handleTrailerActivation,
  isTrailer,
  input: {
    value,
    ...input
  },
  eventHandlers,
  ...props
}) =>
  <Fragment>
    {
      vehicles &&
      <TilesWrapper>
        {
          vehicles.map(({
            url: vehicleImage,
            userVehicleId,
            tireFrontSize,
            tireRearSize,
            masterVehicle,
            vehicleColor,
            vehicleType,
            vehicleNickname
          }) =>
            getIsTrailer({ vehicleType }) ?
              <TrailerTile
                { ...props }
                { ...input }
                tireFrontSize={ tireFrontSize }
                tireRearSize={ tireRearSize }
                key={ userVehicleId }
                model={ vehicleNickname }
                active={ value === userVehicleId && !isTrailer }
                { ...eventHandlers(userVehicleId) } /> :
              <VehicleTile
                { ...props }
                { ...input }
                key={ userVehicleId }
                value={ userVehicleId }
                color={ vehicleColor }
                nickname={ vehicleNickname }
                src={ vehicleImage }
                masterVehicle={ masterVehicle }
                active={ value === userVehicleId && !isTrailer }
                { ...eventHandlers(userVehicleId, masterVehicle) } />
          )
        }
      </TilesWrapper>
    }
    <AddVehicleTile />
    <GenericTrailerTile
      model={ TRAILER_TITLE }
      active={ isTrailer }
      onClick={ handleTrailerActivation } />
  </Fragment>

VehicleSelectorButtonGroup.propTypes = {
  eventHandlers: PropTypes.func,
  handleTrailerActivation: PropTypes.func,
  input: PropTypes.shape(),
  isTrailer: PropTypes.bool,
  vehicles: PropTypes.arrayOf(PropTypes.shape())
}

export default VehicleSelectorButtonGroup

const TilesWrapper = styled.div`
  display: inline-block;
`
